export { default as HomeLayout } from './homeLayout';


// WEBPACK FOOTER //
// ./src/features/layout/index.js